import { faDownload, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import UploadResource from 'models/upload/resource';
import React, { useContext } from 'react';
import Moment from 'react-moment';
import * as Contexts from './Context';

type Props = {
  value: UploadResource,
  onDownloadClick?: () => void
};

export const UploadRow = ({ value, onDownloadClick }: Props) => {
  const { selection, setSelection } = useContext(Contexts.SelectionContext);

  return (
    <tr>
      <td>{value.fileName}</td>
      <td>
        <Moment format="DD-MM-YYYY hh:mm:ss">{value.uploadDate}</Moment>
      </td>
      <td>
        {onDownloadClick && (
          <button type="button" title="Download fil" className="blank-button" onClick={onDownloadClick}>
            <FontAwesomeIcon icon={faDownload} />
          </button>
        )}
        <button type="button" className="blank-button" onClick={() => setSelection({ ...selection, deleting: value })}>
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </td>
    </tr>
  );
};

export default UploadRow;
